import React, { useState } from "react";
import { testimonials } from "../mock/mock";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];

  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((i) => (i + 1) % testimonials.length);

  return (
    <section aria-labelledby="testi-heading" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#6b6b66] mb-3">
              — (05) Word of mouth
            </p>
            <h2 id="testi-heading" className="font-display text-3xl md:text-4xl font-medium leading-tight">
              From founders<br />and growth leads.
            </h2>
            <div className="mt-8 flex items-center gap-2">
              <button
                onClick={prev}
                aria-label="Previous testimonial"
                className="h-11 w-11 rounded-full border border-[#0A0A0A] flex items-center justify-center hover:bg-[#0A0A0A] hover:text-[#C8FF3D] transition-colors"
              >
                <ChevronLeft className="h-4 w-4" />
              </button>
              <button
                onClick={next}
                aria-label="Next testimonial"
                className="h-11 w-11 rounded-full border border-[#0A0A0A] flex items-center justify-center hover:bg-[#0A0A0A] hover:text-[#C8FF3D] transition-colors"
              >
                <ChevronRight className="h-4 w-4" />
              </button>
              <span className="ml-3 font-mono text-xs text-[#6b6b66]">
                {String(idx + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
              </span>
            </div>
          </div>

          <div className="lg:col-span-9 relative">
            <Quote className="absolute -top-12 -left-2 h-14 w-14 text-[#C8FF3D] opacity-90" strokeWidth={1.25} />
            <blockquote
              key={t.id}
              className="fade-up relative font-display text-3xl md:text-4xl lg:text-[44px] leading-[1.2] font-light text-[#0A0A0A] pt-2"
            >
              “{t.quote}”
            </blockquote>
            <div className="mt-10 flex items-end justify-between flex-wrap gap-4 border-t border-[#E5E5E0] pt-6">
              <div>
                <div className="font-medium text-[#0A0A0A] text-base">
                  {t.nameUrl ? (
                    <a
                      href={t.nameUrl}
                      target="_blank"
                      rel="noopener external"
                      className="border-b border-[#0A0A0A]/25 hover:border-[#0A0A0A] transition-colors"
                      data-testid={`testimonial-name-link-${t.id}`}
                    >
                      {t.name}
                    </a>
                  ) : (
                    t.name
                  )}
                </div>
                <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#6b6b66] mt-1">
                  {t.title}{t.company ? ` · ${t.company}` : ""}
                </div>
              </div>
              <div className="flex gap-2">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIdx(i)}
                    aria-label={`Show testimonial ${i + 1}`}
                    className={`h-1.5 transition-all ${
                      i === idx ? "w-10 bg-[#0A0A0A]" : "w-5 bg-[#0A0A0A]/20"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
